import React, { FC } from 'react'
import { Link, useParams } from 'react-router-dom'
import styles from './Menu.module.scss'
import { useCatalog } from 'context/catalog/CatalogContext'
import { useI18n } from 'utils/i18n/hooks/useI18n'

export interface IMenuProps {
    //propertys
    onClickOut?: () => void
    onClickLogin?: () => void
    onClickDeleteAccount?: () => void
}
const Menu: FC<IMenuProps> = ({ onClickOut, onClickLogin, onClickDeleteAccount}) => {
    const { storeId, url } = useParams<{ storeId: string; url: string }>();
    const { catalog } = useCatalog();
    const { t } = useI18n();

    return (
        <div id={styles.Menu} >
            <div className={styles.menu}>
                <ul>
                    {url && <Link to={`/${url}`}><li>{t("menu.home")}</li></Link>}
                    {url && storeId && <Link to={`/${url}/${storeId}`}><li>{t("menu.menu")}</li></Link>}
                    {catalog?.enableShoppingCart !== false && (
                    <Link to={"/pedidos"}><li>{t("menu.orders")}</li></Link>
                    )}
                    {/* <Link to={"/"+url +"/schedule/tour/reserves"}><li>Reservas</li></Link> */}
                    {onClickLogin && <li onClick={onClickLogin}>{t("menu.login")}</li>}
                    {onClickOut && <li onClick={onClickOut}>{t("menu.logout")}</li>}
                    {onClickDeleteAccount && <li style={{color: "red"}} onClick={onClickDeleteAccount}>{t("menu.deleteAccount")}</li>}              
                </ul>
            </div>
            <div className={styles.menuFaq}>
                {/* <img src={Help} alt="Logo de ajuda"/>
                <ul>         
                    <Link to={"/"+url +"/schedule/tour/faq"}><li>Ajuda</li></Link>
                </ul> */}
            </div>
        </div>
    )
}
export default Menu